module.exports = __webpack_public_path__ + "static/media/act-domain.988e0d83.svg";